// components/PrivateRoute.jsx
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./AuthContext";

const PrivateRoute = ({ roles = [], userIds = [] }) => {
  const { user, loading } = useAuth();

  // Block rendering until loading is done
  if (loading) return null; // or a spinner component

  const isAuthorized =
    user &&
    (roles.length === 0 || roles.includes(user.role)) &&
    (userIds.length === 0 || userIds.includes(user.id));

  return isAuthorized ? <Outlet /> : <Navigate to="/unauthorized" replace />;
};

export default PrivateRoute;